/** Laminated Tempered 11.52mm / 13.52mm color options (Glass Roof) */
export const glassLamiTemperedColorOptions = [
    "Light Blue Geen",
    "Light Grey",
    "Light Bronze",
    "Light Blue",
    "Clear",
    "Translucent White",
    "Dark Brown",
];
